<template>
    <div>
        <div class="el-Require">
            <el-row class="page_content">
                <h1 class="head_title">专升本资格审查</h1>

                <div class="material-container">
                    <!-- 一、填写对应内容 -->
                    <div class="form-section">
                        <div class="audit-status-bar" v-if="reviewStatus">
                            <div>当前状态：</div>
                            <div
                                class="audit-item status-pending"
                                v-if="reviewStatus == 1"
                            >
                                <div class="audit-text">审核中</div>
                            </div>

                            <div
                                class="audit-item status-pass"
                                v-if="reviewStatus == 2"
                            >
                                <div class="audit-text">审核通过</div>
                            </div>

                            <div
                                class="audit-item status-reject"
                                v-if="reviewStatus == 3"
                            >
                                <div class="audit-text">
                                    审核不通过：
                                    <span class="reject-reason">{{
                                        rejectionReason
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <h2 class="section-title">一、请填写对应内容</h2>
                        <div class="form-card">
                            <el-form
                                ref="formRef"
                                :model="form"
                                :rules="rules"
                                label-width="180px"
                                class="common-form"
                                :disabled="isEdit"
                            >
                                <el-form-item
                                    label="报告编号/在线验证码"
                                    prop="onlineCode"
                                >
                                    <el-input
                                        v-model="form.onlineCode"
                                        placeholder="请填写学历报告编号或在线验证码"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科毕业证书编号"
                                    prop="collegeCertNo"
                                >
                                    <el-input
                                        v-model="form.collegeCertNo"
                                        placeholder="请填写专科毕业证书编号"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科毕业院校名称"
                                    prop="collegeSchoolName"
                                >
                                    <el-input
                                        v-model="form.collegeSchoolName"
                                        placeholder="请填写专科毕业院校全称"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科所学专业"
                                    prop="collegeMajorName"
                                >
                                    <el-input
                                        v-model="form.collegeMajorName"
                                        placeholder="请填写专科所学专业名称"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <!-- 二、上传证明材料 -->
                    <div class="upload-section-box">
                        <h2 class="section-title">二、请上传证明材料</h2>
                        <div class="upload-tips-list">
                            <p>1、专科毕业证书扫描件或照片</p>
                            <p>1、身份证和户口页扫描件或照片</p>
                            <p>3、学历证书注册备案表或学历认证报告</p>
                        </div>

                        <div class="upload-content-wrapper">
                            <div class="upload-main">
                                <el-upload
                                    :action="uploadUrl"
                                    list-type="picture-card"
                                    :file-list="form.photoUrl"
                                    :show-file-list="false"
                                    :headers="headers"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    :on-exceed="handleExceed"
                                    :on-success="handleSuccess"
                                    :disabled="isEdit"
                                    multiple
                                    :limit="10"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <div class="upload-desc">
                                    <p>上传说明：</p>
                                    <p>- 支持格式：PNG、PDF</p>
                                    <p>
                                        - 上传清晰完整的扫描件/照片，文字可辨识
                                    </p>
                                </div>
                            </div>
                            <div
                                class="file-list-display"
                                v-if="form.photoUrl.length > 0"
                            >
                                <div
                                    class="file-item"
                                    v-for="(file, index) in form.photoUrl"
                                    :key="index"
                                >
                                    <span
                                        class="file-name"
                                        @click="handlePreview(file)"
                                        >{{ file.name }}</span
                                    >
                                    <i
                                        v-if="!isEdit"
                                        class="el-icon-close file-delete"
                                        @click="removeFileByIndex(index)"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 提交按钮 -->
                    <div class="btn-box">
                        <el-button
                            type="primary"
                            size="default"
                            :disabled="isEdit"
                            @click="handleSubmit"
                            class="submit-btn"
                        >
                            提交
                        </el-button>
                    </div>
                </div>
            </el-row>
        </div>

        <el-dialog :visible.sync="dialogVisible" title="预览">
            <img
                v-if="previewType != 'pdf'"
                width="100%"
                :src="dialogImageUrl"
                alt=""
            />
            <iframe
                v-else
                :src="dialogImageUrl"
                frameborder="0"
                style="width: 100%; height: 500px"
            ></iframe>
        </el-dialog>
    </div>
</template>

<script>
import APIDOC from "@/common/serverApi";
import { getCookieForRoleTag } from "../../common/ulit";
import {
    get,
    post,
    postJSON,
    postParams,
    postFormData,
} from "@/common/request";
export default {
    name: "AddReviewProgram",
    data() {
        return {
            //  1待审核 2审核通过 3审核不通过
            reviewStatus: 0,
            // 审核不通过原因
            rejectionReason: "",
            dialogImageUrl: "",
            dialogVisible: false,
            previewType: "",
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: {
                token: getCookieForRoleTag(),
                _role_tag: getCookieForRoleTag()
                    ? getCookieForRoleTag().split(".")[
                          getCookieForRoleTag().split(".").length - 1
                      ]
                    : null,
            }, //请求头
            formRef: null,
            isEdit: false,
            form: {
                onlineCode: "",
                collegeCertNo: "",
                collegeSchoolName: "",
                collegeMajorName: "",
                photoUrl: [],
            },
            rules: {
                onlineCode: [
                    {
                        required: true,
                        message: "请填写报告编号/在线验证码",
                        trigger: "blur",
                    },
                ],
                collegeCertNo: [
                    {
                        required: true,
                        message: "请填写专科毕业证书编号",
                        trigger: "blur",
                    },
                ],
                collegeSchoolName: [
                    {
                        required: true,
                        message: "请填写专科毕业院校名称",
                        trigger: "blur",
                    },
                ],
                collegeMajorName: [
                    {
                        required: true,
                        message: "请填写专科所学专业",
                        trigger: "blur",
                    },
                ],
                photoUrl: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.photoUrl.length === 0) {
                                callback(new Error("请至少上传一张证明材料"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        // 图片预览
        handlePreview(file) {
            console.log(file);
            this.previewType = file.name.split(".").pop();
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 移除文件
        handleRemove(file, photoUrl) {
            this.form.photoUrl = photoUrl;
        },
        // 删除前确认
        beforeRemove(file) {
            return this.$confirm(`确定删除【${file.name}】吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            });
        },
        // 根据索引移除文件
        removeFileByIndex(index) {
            this.form.photoUrl.splice(index, 1);
        },
        // 超出数量限制
        handleExceed() {
            this.$message.warning("最多只能上传10张图片，请删除后再试");
        },
        // 上传成功
        handleSuccess(res, file) {
            console.log("上传成功：", this.$baseUrl);
            console.log("上传成功：", res, file);
            this.form.photoUrl.push(file);
        },
        // 提交表单
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (!valid) {
                    return;
                }
                const studentStatusId = JSON.parse(
                    sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())
                ).studentStatusId;
                console.log("提交数据：", this.form.photoUrl);
                let params = {
                    studentStatusId,
                    ...this.form,
                    photoUrl: this.form.photoUrl
                        .map((item) =>
                            item.response ? item.response.data.url : item.url
                        )
                        .join(","),
                };

                post(APIDOC.USER.submitStudentApplyInfo, {
                    studentStatusId,
                    ...params,
                }).then((res) => {
                    if (res.statusId) {
                        this.$message.success("材料提交成功，等待审核");
                        this.getData();
                    }
                });
                // // 模拟提交接口
                // this.$message.success("材料提交成功，等待审核");
                // console.log("提交数据：", studentStatusId);
                // console.log("最终提交数据：", params);
            });
        },

        // 获取详情
        getData() {
            const studentStatusId = JSON.parse(
                sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())
            ).studentStatusId;
            get(APIDOC.USER.getStudentDataInfo, {
                studentStatusId,
            }).then((res) => {
                console.log("获取详情：", res);
                console.log("获取详情：");
                if (res.code === 0) {
                    this.reviewStatus = res.data.checkStatus;
                    this.rejectionReason = res.data.rejectionReason;
                    if (res.data.checkFlag == "2") {
                        this.isEdit = true;
                        this.$message.success("您无需进行专升本资格审查");
                        return;
                    }

                    if (
                        res.data.onlineCode &&
                        res.data.onlineCode &&
                        res.data.checkStatus != "3"
                    ) {
                        this.isEdit = true;
                    } else {
                        this.isEdit = false;
                    }

                    this.form = {
                        onlineCode: res.data.onlineCode,
                        collegeCertNo: res.data.collegeCertNo,
                        collegeSchoolName: res.data.collegeSchoolName,
                        collegeMajorName: res.data.collegeMajorName,
                        photoUrl: res.data.photoUrl
                            ? res.data.photoUrl.split(",").map((item) => ({
                                  name: item.split("\\").pop(),
                                  url:
                                      this.$baseUrl +
                                      item.replace(/\\\\/g, "\\"),
                              }))
                            : [],
                    };
                }
            });
        },
    },

    mounted() {
        this.getData();
    },
};
</script>

<style scoped>
.audit-status-bar {
    display: flex;
    font-size: 24px;
    font-weight: bold;
}

.audit-text {
    white-space: nowrap;
}
/* 状态样式 */
.status-reject {
    color: #ff4444;
}
.status-pending {
    color: #ff9933;
}
.status-pass {
    color: #44aa44;
}
/* 容器 */
.material-container {
    max-width: 900px;
    padding: 0 20px;
    position: relative;
}

/* 标题 */
.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
}

/* 表单区域 */
.form-section {
    padding: 0 20px;
    border-radius: 4px;
}
.form-card {
    padding-left: 20px;
}
.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.form-row:last-child {
    margin-bottom: 0;
}
.form-label {
    width: 160px;
    font-size: 14px;
    color: #333;
}
.form-input {
    flex: 1;
}

/* 上传证明材料区域 */
.upload-section-box {
    border-radius: 4px;
    padding: 20px;
}
.upload-tips-list {
    font-size: 14px;
    margin-bottom: 20px;
    color: #333;
    padding-left: 20px;
}
.upload-content-wrapper {
    /* display: flex; */
    gap: 16px;
    align-items: flex-start;
    padding-left: 20px;
}
.upload-main {
    flex: 1;
    display: flex;
    align-items: end;
}
.upload-desc {
    font-size: 12px;
    color: #666;
    margin-top: 10px;
    margin-left: 20px;
}
.file-list-display {
    margin-top: 12px;
}
.file-item {
    display: block;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 8px;
    font-size: 13px;
}
.file-name {
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
    margin-right: 6px;
}
.file-delete {
    color: #f56c6c;
    cursor: pointer;
    font-size: 12px;
    background: #f56c6c;
    color: #fff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.upload-tip-right {
    background-color: #f7d774;
    padding: 12px 16px;
    border-radius: 4px;
    font-size: 12px;
    color: #333;
    line-height: 1.6;
    min-width: 180px;
    white-space: nowrap;
}

/* 按钮 */
.btn-box {
    text-align: left;
    padding-left: 40px;
}
.submit-btn {
    /* background-color: #009688; */
    /* border-color: #009688; */
    padding: 10px 50px;
}
.submit-btn:hover,
.submit-btn:focus {
    background-color: #007d71;
    border-color: #007d71;
}
</style>



// WEBPACK FOOTER //
// src/pages/addReviewProgram/index.vue